<h1 class="text-white text-lg font-semibold mb-4">Gestión de Usuarios</h1>
<div class="mb-4">
    <button matButton (click)="onCreateUser()" *ngIf="canCreateUser$ | async">Crear Nuevo Usuario</button>
</div>
<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">
    <p>No hay usuarios registrados.</p>
</div>
<div class="mat-elevation-z2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full">
        <ng-container matColumnDef="uid">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Código </th>
            <td mat-cell *matCellDef="let user"> {{ user.uid }} </td>
        </ng-container>
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
            <td mat-cell *matCellDef="let user" class="no-uppercase"> {{ user.email }} </td>
        </ng-container>
        <ng-container matColumnDef="displayName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
            <td mat-cell *matCellDef="let user"> {{ user.displayName }} </td>
        </ng-container>
        <ng-container matColumnDef="disabled">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Activo </th>
            <td mat-cell *matCellDef="let user"> {{ user.disabled ? 'No' : 'Si' }} </td>
        </ng-container>
        <ng-container matColumnDef="creationTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>
            <td mat-cell *matCellDef="let user">{{ user.creationTime | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="lastSignInTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Último acceso </th>
            <td mat-cell *matCellDef="let user">{{ user.lastSignInTime | date:'dd-MM-yyyy, hh:mm:ss a' }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Acciones </th>
            <td mat-cell *matCellDef="let user">
                <button mat-icon-button color="accent" aria-label="Editar usuario" (click)="onEditUser(user)" *ngIf="canEditUser$ | async">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" aria-label="Eliminar usuario" (click)="onDeleteUser(user.uid)" *ngIf="canDeleteUser$ | async">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements"></mat-paginator>
</div>
